import React from "react";
import styled from "styled-components";
import { TableCellProps } from "../../types";

const StyledTableCell = styled.td<{
  $isToday?: boolean;
  $rgba_light_bg?: { r: number; g: number; b: number; a: number };
  $rgba_light_text?: { r: number; g: number; b: number; a: number };
}>`
  text-align: center;
  background-color: ${({ $isToday, $rgba_light_bg }) =>
    $isToday
      ? `rgba(${$rgba_light_bg?.r}, ${$rgba_light_bg?.g}, ${$rgba_light_bg?.b}, ${$rgba_light_bg?.a})`
      : "inherit"};
  color: ${({ $isToday, $rgba_light_text }) =>
    $isToday
      ? `rgba(${$rgba_light_text?.r}, ${$rgba_light_text?.g}, ${$rgba_light_text?.b}, ${$rgba_light_text?.a})`
      : "inherit"};
`;

export const PrayerTableCell = React.memo(({
  content,
  isToday,
  rgba_light_bg,
  rgba_light_text
}: TableCellProps) => (
  <StyledTableCell
    $isToday={isToday}
    $rgba_light_bg={rgba_light_bg}
    $rgba_light_text={rgba_light_text}
    className="text-center"
  >
    {content}
  </StyledTableCell>
));